import { render, staticRenderFns } from "./PaymentRegist.vue?vue&type=template&id=5da96055&scoped=true&"
import script from "./PaymentRegist.vue?vue&type=script&lang=js&"
export * from "./PaymentRegist.vue?vue&type=script&lang=js&"
import style0 from "./PaymentRegist.vue?vue&type=style&index=0&id=5da96055&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da96055",
  null
  
)

export default component.exports